var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.oferta.destaque)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({attrs:{"small":"","color":"secondary"}},on),[_vm._v("mdi-tag")])]}}],null,false,1160662809)},[_c('span',[_vm._v("Oferta em destaque")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }